import { ProtectorType } from 'core/constants';

/** Stored types a migrated or API-authored template can carry that the builder cannot edit. */
export const INERT_TYPES: ProtectorType[] = [ProtectorType.Time, ProtectorType.RepeatingGroup];

export const CHOICE_TYPES: ProtectorType[] = [
  ProtectorType.SingleChoice,
  ProtectorType.MultiChoice,
  ProtectorType.YesNoNa,
];

export const SINGLE_ANSWER_CHOICE_TYPES: ProtectorType[] = [ProtectorType.SingleChoice, ProtectorType.YesNoNa];

/** Server-fixed: any other key is refused. */
export const YES_NO_NA_OPTIONS: ReadonlyArray<{ key: string; value: string; colour: string | null }> = [
  { key: 'yes', value: 'Yes', colour: 'success' },
  { key: 'no', value: 'No', colour: 'error' },
  { key: 'na', value: 'N/A', colour: null },
];

export interface AuditOption {
  key: string;
  value: string;
  score: number | null;
  colour: string | null;
}

/** The stored `properties` object. What the builder does not author is carried through verbatim. */
export interface AuditQuestionProperties {
  [key: string]: unknown;
}

export interface AuditQuestion {
  key: string;
  description: string;
  questionType: ProtectorType;
  required: boolean;
  options: AuditOption[];
  lookupType: string | null;
  multiple: boolean;
  image: { uuid: string; file?: string } | null;
  /** Kept for round-trip fidelity. */
  unauthoredProperties: AuditQuestionProperties;
}

export type AuditActionWhen = { equals: [string, string[]] } | true;

export type AuditActionThen = { nextSection: string } | { submit: true };

export interface AuditAction {
  when: AuditActionWhen;
  then: AuditActionThen;
}

export interface AuditSection {
  key: string;
  title: string;
  description: string;
  questions: AuditQuestion[];
  actions: AuditAction[];
}

export interface AuditFormModel {
  sections: AuditSection[];
}

/** Publish blocks on names that clash case-insensitively, so `Add section` has to avoid one the same way. */
export const sectionTitleId = (title: string): string => title.trim().toLowerCase();

export const SECTION_NEXT_DEFAULT = 'next';
export const SECTION_NEXT_SUBMIT = 'submit';
